import { useMutation } from '@apollo/client/react';
import { Button } from '@optools/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@optools/components/ui/dialog';
import { BORROW_PIPELINE } from '@optools/services/operator-gateway/qa-tools/mutations';
import { PIPELINE_MONITORS } from '@optools/services/operator-gateway/qa-tools/queries';
import { PlusCircle } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { TeamPicker } from './team-picker';

export function BorrowPipelineDialog() {
  const [open, setIsOpen] = useState(false);
  const [teamId, setTeamId] = useState(-1);
  const [borrowPipeline, { loading }] = useMutation(BORROW_PIPELINE, {
    onCompleted: ({ borrowPipeline }) => {
      if (!borrowPipeline) {
        toast.error('Borrow Pipeline Error', {
          description: `Failed to borrow pipeline for team: ${teamId} from production`,
          duration: Infinity,
        });
        return;
      } else {
        toast.success('Borrow Pipeline', {
          description: `Pipeline for team: ${teamId} borrowed from production`,
        });
        setIsOpen(false);
        setTeamId(-1);
      }
    },
    refetchQueries: [{ query: PIPELINE_MONITORS }],
  });

  const handleBorrowPipeline = async () => {
    if (teamId === -1) {
      return;
    }

    await borrowPipeline({ variables: { teamId } });
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        setIsOpen(open);
        setTeamId(-1);
      }}>
      <DialogTrigger asChild>
        <Button aria-label="borrow a pipeline from production" size="icon-sm">
          <PlusCircle />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Borrow Pipeline From Production</DialogTitle>
          <DialogDescription>Select a team to borrow pipeline from production</DialogDescription>
        </DialogHeader>
        <TeamPicker
          disabled={false}
          loading={loading}
          message=""
          selectedTeamId={teamId}
          title="Team"
          onSelectTeam={setTeamId}
        />
        <DialogFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setIsOpen(false);
              setTeamId(-1);
            }}>
            Cancel
          </Button>
          <Button
            disabled={teamId === -1 || loading}
            loading={loading}
            onClick={handleBorrowPipeline}>
            Borrow
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
